import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ItemTypes, MenuCategories } from '~/components/Modals/GemShop/GemShop.types'

import { RootState } from '~/redux/store'

interface GemShopState {
  isShowingGemShop: boolean
  showItem?: string
  ShowCategory?: MenuCategories
  showSection?: ItemTypes
  didPurchase: boolean
  isLocked: boolean
}

const initialState: GemShopState = {
  isShowingGemShop: false,
  showItem: undefined,
  ShowCategory: undefined,
  showSection: undefined,
  didPurchase: false,
  isLocked: false,
}

const slice = createSlice({
  name: 'gemShop',
  initialState,
  reducers: {
    showGemShop: (state) => {
      return {
        ...state,
        isShowingGemShop: true,
      }
    },

    hideGemShop: (state) => {
      return {
        ...state,
        isShowingGemShop: false,
      }
    },
    setShowItem: (state, action: PayloadAction<string | undefined>) => {
      return {
        ...state,
        showItem: action.payload,
      }
    },
    setShowSection: (state, action: PayloadAction<ItemTypes | undefined>) => {
      return {
        ...state,
        showSection: action.payload,
      }
    },
    setShowCategory: (state, action: PayloadAction<MenuCategories | undefined>) => {
      return {
        ...state,
        ShowCategory: action.payload,
      }
    },
    setDidPurchase: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        didPurchase: action.payload,
      }
    },
    setIsLocked: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isLocked: action.payload,
      }
    },
  },
})
export const selectShowGemShop = (state: RootState): boolean => state.gemShop.isShowingGemShop
export const selectShowItem = (state: RootState): string | undefined => state.gemShop.showItem
export const selectShowSection = (state: RootState): ItemTypes | undefined => state.gemShop.showSection
export const selectShowCategory = (state: RootState): MenuCategories | undefined => state.gemShop.ShowCategory
export const selectdidPurchase = (state: RootState): boolean => state.gemShop.didPurchase
export const selectIsLocked = (state: RootState): boolean => state.gemShop.isLocked
export const { showGemShop, hideGemShop, setShowItem, setShowSection, setShowCategory, setDidPurchase, setIsLocked } =
  slice.actions

export default slice.reducer
